<div class="container-fluid" id="body">
    <div class="row">
        <div class="col-12" *ngIf="isLoading">
            <app-busy [message]="message"></app-busy>
        </div>
    </div>
    <div class="row">
        <div class="col-12">

            <div class="account-statement-header">

                <img src="../../../../../assets/newimg/arrow-1-3@2x.png" (click)="onBack()"
                     style="cursor: pointer;margin: 10px;"/>
                <div class="contact-details opensans-semi-bold-sapphire-30px">
                    <span class="opensans-semi-bold-sapphire-30px"> Account Statement</span>
                </div>
                <div class="rectangle-34"></div>

                <div class="row">
                    <div class="col-md-6 pt-4">
                        Account Name:
                    </div>
                    <div class="col-md-6 pt-4">
                        {{debtoraccount.customer_name}}
                    </div>
                    <div class="col-md-6  pt-4">
                        Account ID:
                    </div>
                    <div class="col-md-6  pt-4">
                        {{debtoraccount.customer_code}}
                    </div>
                    <div class="col-md-6  pt-4">
                        Account balance:
                    </div>
                    <div class="col-md-6  pt-4">
                        {{debtoraccount.AccountBalance * -1 ? (debtoraccount.AccountBalance * -1 | currencyFormat) : 'R 0.00' }}
                    </div>
                    <div class="col-md-6  pt-4">
                        Contact Person:
                    </div>
                    <div class="col-md-6  pt-4">
                        {{debtoraccount.contact_person}}
                    </div>
                    <div class="col-md-6  pt-4">
                        Email Address:
                    </div>
                    <div class="col-md-6  pt-4">
                        {{debtoraccount.email}}
                    </div>
                    <div class="col-md-12 pt-4">
                        <br/>
                    </div>
                    <div class="col-md-12">
                        <table style="border-collapse: collapse; width: 100%;">
                            <tr>
                                <td style="padding: 5px;vertical-align: middle;"> Statement From:
                                    <br/>
                                    <br/>
                                </td>
                                <td style="padding: 5px;vertical-align: middle;"><input type="text"
                                                                                        class="form-control input-sm form-control-sm myDate"
                                                                                        ngbDatepicker
                                                                                        (ngModelChange)="(dateFrom = $event)"
                                                                                        #fromDate="ngbDatepicker"
                                                                                        placeholder="yyyy/MM/dd"
                                                                                        name="dateFrom"
                                                                                        [ngModel]="dateFrom"
                                                                                        value="{{ dateFrom | date:'yyyy/MM/dd' }}"/>
                                    <button class="btn btn-outline-secondary bi bi-calendar myBDate"
                                            (click)="fromDate.toggle()" type="button"></button>
                                </td>
                                <td style="padding: 5px;vertical-align: middle;">Statement To:
                                    <br/>
                                    <br/>
                                </td>
                                <td style="padding: 5px;vertical-align: middle;"><input type="text"
                                                                                        class="form-control input-sm form-control-sm myDate"
                                                                                        ngbDatepicker
                                                                                        (ngModelChange)="(dateTo = $event)"
                                                                                        #d5="ngbDatepicker"
                                                                                        placeholder="dd/mm/yyyy"
                                                                                        name="dateTo"
                                                                                        [ngModel]="dateTo"/>
                                    <button class="btn btn-outline-secondary  myBDate bi bi-calendar3"
                                            (click)="d5.toggle()" type="button"></button>
                                </td>
                                <td style="padding: 5px;vertical-align: middle;">
                                    <button title="Get Statement" class="btn-add_2 btn" (click)="onSearch()"
                                            type="submit">Filter
                                    </button>
                                    <br/>
                                    <br/>
                                </td>
                                <td style="padding: 5px;vertical-align: middle;">
                                    <button title="Get Statement" class="btn-add_2 btn" (click)="onReset()"
                                            type="submit">Reset
                                    </button>
                                    <br/>
                                    <br/>
                                </td>
                            </tr>
                        </table>

                    </div>
                    <!-- End of the Carrier Details -->

                    <table class="table table-sm table-striped" style="border-top:none;width:100%" id="transactions">
                        <thead class="" style="background:white!important;border-top:none;">
                        <tr style="vertical-align:middle;">
                            <th scope="col">Date</th>
                            <th scope="col">Reference Number</th>
                            <th scope="col">Description</th>
                            <th scope="col">Transaction Type</th>
                            <th scope="col" style="text-align: right;">Transaction Total</th>

                        </tr>
                        </thead>
                        <tr *ngFor="let transc of listTransactions | paginate: { itemsPerPage: 10, currentPage: page }">
                            <td>{{transc.transaction_date |  date:'dd/MM/yyyy'}}</td>
                            <td *ngIf="transc.transaction_type == 'INV' || transc.transaction_type == 'INVP'"><a href="javascript:void(0);" (click)="(GetInvoice(transc.reference_number))">{{transc.reference_number}}</a></td>
                            <td *ngIf="transc.transaction_type != 'INV' && transc.transaction_type != 'INVP'">{{transc.reference_number}}</td>
                            <td>{{transc.transaction_description}}</td>
                            <td>{{transc.transaction_type}}</td>
                            <td class="text-right">
                                {{transc.transaction_total * -1 ? (transc.transaction_total * -1 | currencyFormat) : 'R 0.00' }}</td>
                        </tr>
                        <tr *ngIf="listTransactions.length===0">
                            <td colspan="9" class="rm-brd">
                                <span class="text-info no-info">The is currently no data to display. Please select a start and end date to retrieve transactional information for this account.</span>
                            </td>
                        </tr>
                        <tfoot>
                        <tr *ngIf="listTransactions.length > 0">
                            <td colspan="9" class="rm-brd">
                                <pagination-controls (pageChange)="page = $event"
                                                     style="margin:0px;padding:0px;"></pagination-controls>
                            </td>
                        </tr>
                        </tfoot>


                        <!-- <tfoot style="padding:0px;margin:0px;">
                          <tr *ngIf="count > 10" style="padding-left:0px;margin-left:0px;">
                            <td colspan="8" class="rm-brd" style="padding-left:0px;margin-left:0px;">
                              <div class="row">

                                <div class="col-2">
                                  <div class="input-group mb-3 rm-brd" style="width:125px!important;height:30px!important;">
                                    <div class="input-group-prepend">
                                      <label class="input-group-text form-control-sm show-h" for="show-id" style="">Show:</label>
                                    </div>
                                    <select class="form-control form-control-sm show-h" id="show-id" [(ngModel)]="pageSize" (change)="onChange()">
                                      <option *ngFor="let key of utility.pageItems" [ngValue]="key">{{key}}</option>
                                    </select>
                                  </div>
                                </div>
                                <div class="col-8 text-center">
                                  <pagination-controls (pageChange)="page = $event" style="margin:0px;padding:0px;"></pagination-controls>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr *ngIf="isEmpty">
                            <td colspan="4" class="rm-brd">
                              <span class="text-info text-small">No Transactions Available for this account.</span>
                            </td>
                          </tr>
                        </tfoot> -->
                    </table>


                </div>

                <div class="col-12">
                    <br/>
                    <br/>
                    <div class="button-container">

                        <button class="btn btn-outline-custom" type="submit" (click)="emailStatement()"
                                title="Email your statement">
                            Email
                        </button>
                        &nbsp; &nbsp;&nbsp;
                        <button title="Download the statement" class="btn-add_2 btn" (click)="downloadStatement()"
                                type="submit">Download
                        </button>
                    </div>
                </div>
            </div>

            <!-- <footer style="margin:0px;padding:0px;">
            <div class="row" style="margin:0px;padding:0px;">

              <div class="col-12" style="margin:0px;padding:0px;"> -->
            <!--<footer class="footer">-->
            <!-- <div class="container-fluid" style="background-color:rgb(242,242,242) !important;height:75px!important;margin-bottom:1px!important;">
              <div class="row">
                <div class="col-md-12" *ngIf="isLoading">
                  <app-busy [message]="message"></app-busy>
                </div>
                <div class="col-6"></div>
                <div class="col-6">
                  <div class="row">
                    <div style="width: 70px;height: 70px;" class="col-2">
                      <div class="" title="Cancel" style="margin: 0px auto;" rel="tooltip" data-placement="top">
                        <div class="app-cancel" (click)="cancel()"></div>
                      </div> -->
            <!-- <div class="lbl-app" style="margin: 1px auto;">
                        <span>Cancel</span>
                      </div> -->
            <!-- </div>
                    <div style="width: 70px;height: 70px;" class="col-2">
                      <div class="" title="Download Statement" style="margin: 0px auto;" rel="tooltip" data-placement="top">
                            <div id="download-statement"  (click)="download()"></div>
                      </div>
                    </div>
                    <div style="width: 70px;height: 70px;" class="col-2">
                      <div class="" title="Email Statement" style="margin: 0px auto;" rel="tooltip" data-placement="top">
                       <div id="email-statement"  (click)="emailStatement()"></div>
                     </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
            <!--</footer>-->
            <!-- </div>

              </div>
          </footer> -->
